import Container from 'components/Container'
import Layout from 'components/layouts/Layout'
import { useTranslation } from 'next-i18next'
import Error from 'next/error'
import Head from 'next/head'
import React from 'react'

const CustomErrorPage = () => {
  const { t } = useTranslation()

  return (
    <>
      <Head>
        <title>{t('Server Error')}</title>
      </Head>

      <Container>
        <div className='grid grid-cols-1 divide-y-8 divide-gray-100 rounded-2xl'>
          <Error statusCode={404} />
        </div>
      </Container>
    </>
  )
}

CustomErrorPage.getLayout = function getLayout(page: React.ReactElement) {
  return <Layout>{page}</Layout>
}

export default CustomErrorPage
